/** `API Credential Type` on the copy events this page fires. */
export const CREDENTIAL_TYPE = 'Tracking';

/** `API Credential Type` for the JavaScript snippets, which are not a credential. */
export const SNIPPET_CREDENTIAL_TYPE = 'JavaScript';

/** `Source` on every copy event this page fires. */
export const COPY_SOURCE = 'Integration Page (C.io API)';
